import React from 'react'
import { THEME, verticalTalentPhotos } from 'utils'
import Link from 'next/link'

const TalentGrid = ({ talent }) => (
  <>
    <div className='talentGrid'>
      {talent.map((talent, idx) => {
        const { img, link } = verticalTalentPhotos[talent] || {
          img: 'https://chumley.barstoolsports.com/wp-content/uploads/2017/07/07/Screen-Shot-2017-07-07-at-3.06.47-PM.png?width=120&height=120'
        }
        return (
          <div className='talentGrid__col' key={idx}>
            <Link href={link || 'https://www.barstoolsports.com/'}>
              <a>
                <img src={img} alt={talent} />
              </a>
            </Link>
            <h5>{talent}</h5>
          </div>
        )
      })}
    </div>
    <style jsx>{`
      .talentGrid {
        margin-top: 0.75rem;
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-gap: 10px;
      }
      .talentGrid__col {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .talentGrid__col a {
        width: 100%;
      }
      .talentGrid__col img {
        display: block;
        width: 75%;
        border-radius: 50%;
        margin: auto;
        // border: 2px solid #C9C8C8;
      }
      .talentGrid__col h5 {
        text-align: center;
        margin: 0.4rem 0 0;
        font-size: 3vw;
      }
      @media (min-width: 370px) {
        .talentGrid__col h5 {
          font-size: 0.75rem;
        }
      }
      @media (min-width: 400px) {
      }
      @media (min-width: ${THEME.BREAKPOINTS.XS}px) {
        .talentGrid {
          margin-top: 1rem;
          grid-gap: 10px;
        }
        .talentGrid__col img {
          width: 60%;
        }
        .talentGrid__col h5 {
          margin: 0.5rem 0 0;
          font-size: 0.9rem;
        }
      }
      @media (min-width: 700px) {
        .talentGrid__col img {
          width: 55%;
        }
        .talentGrid__col h5 {
          font-size: 1rem;
        }
      }
      @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
        .talentGrid {
          margin-top: 0.75rem;
          grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
          grid-gap: 5px;
        }
        .talentGrid__col img {
          width: 74%;
        }
        .talentGrid__col h5 {
          margin: 0.25rem 0 0;
          font-size: 1.2vw;
        }
      }
      @media (min-width: 825px) {
        .talentGrid__col h5 {
          font-size: 1.25vw;
        }
      }
      @media (min-width: ${THEME.BREAKPOINTS.MD}px) {
        .talentGrid {
          grid-template-columns: 1fr 1fr 1fr 1fr;
        }
        .talentGrid__col img {
          width: 72%;
        }
        .talentGrid__col h5 {
          font-size: 1.02vw;
        }
      }
      @media (min-width: ${THEME.BREAKPOINTS.LG}px) {
        .talentGrid {
          grid-column-gap: 15px;
          grid-row-gap: 5px;
        }
        .talentGrid__col img {
          width: 70%;
        }
        .talentGrid__col h5 {
          font-size: 0.99vw;
        }
      }
      @media (min-width: ${THEME.BREAKPOINTS.XL}px) {
        .talentGrid__col h5 {
          font-size: 0.75rem;
        }
      }
    `}</style>
  </>
)

const SideGrid = ({ items, showType = false }) => {
  return (
    <>
      <ul>
        {items.map((item, idx) => (
          <li className={`sideGrid__item ${showType && 'item--showType'}`} key={idx}>
            {item}
          </li>
        ))}
      </ul>
      <style jsx>{`
        ul {
          display: grid;
          grid-template-columns: 1fr 1fr;
          list-style-type: disc;
          margin: 0;
          padding: 0 0 0 20px;
        }
        .sideGrid__item {
          margin: 2% 0;
          font-size: 3.6vw;
          width: auto;
        }
        .item--showType {
          grid-column: 1/4;
        }
        @media (min-width: 370px) {
        }
        @media (min-width: 400px) {
        }
        @media (min-width: ${THEME.BREAKPOINTS.XS}px) {
          .sideGrid__item {
            font-size: 2.9vw;
            margin: 1.5% 0;
          }
        }
        @media (min-width: 700px) {
          .sideGrid__item {
            font-size: 2.75vw;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          ul {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr;
          }
          .sideGrid__item {
            font-size: 1.75vw;
            margin: 5px 0;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.MD}px) {
          ul {
            display: block;
          }
          .sideGrid__item {
            margin: 8% 0;
            font-size: 1.35vw;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.XL}px) {
          .sideGrid__item {
            font-size: 1rem;
          }
        }
      `}</style>
    </>
  )
}

const VerticalShow = ({
  backgroundColor = '#343434',
  logo = false,
  name,
  img,
  about,
  talent,
  integration,
  showType
}) => {
  return (
    <>
      <div className='verticalShow'>
        <div className='verticalShow__header' style={{ backgroundColor }}>
          {logo && <img src={logo} alt={name} />}
          <h2>{name}</h2>
        </div>
        <img className='verticalShow__img' src={img} alt={name} />
        <div className='verticalShow__about'>
          <h3>ABOUT</h3>
          <p>{about}</p>
        </div>
        <div className='verticalShow__talent'>
          <h3>TALENT INVOLVED</h3>
          <TalentGrid talent={talent} />
        </div>
        <div className='verticalShow__integration'>
          <h3>SHOW TYPE</h3>
          <SideGrid items={[showType]} showType />
          <div className='verticalShow__spacer' />
          <h3>INTEGRATION OPPORTUNITIES</h3>
          <SideGrid items={integration} />
        </div>
      </div>
      <style jsx>{`
        .verticalShow {
            width: 100%;
            //background: #ffffff;
            background-color: #f5f5f5;
            padding: 0.5rem;
            display: grid;
            grid-template-columns: 1fr;
            grid-gap: .5rem;
        }
        .verticalShow__header {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: white;
            padding: 0.5rem;
        }
        .verticalShow__header img {
            width: 20%;
            // height: 100%;
        }
        h2 {
            margin: 1rem;
            margin-right: 0;
            font-size: 4.5vw;
            text-transform: uppercase;
        }
        .verticalShow__img {
            width: 100%;
        }
        .verticalShow__about, .verticalShow__talent, .verticalShow__integration {
            padding: 0 .5rem;
            margin-bottom: .25rem;
        }
        h3 {
            color: #eb3e3f;
            margin: .25rem 0;
            font-size: 4.25vw;
        }
        p {
            line-height: 1.57;
            width: 100%;
            padding: 0;
            margin: 0;
            font-size 3.75vw;
        }
        .verticalShow__spacer {
          height: 8px;
        }
        @media (min-width: 370px) {
            .verticalShow__header {
                padding: .75rem;
            }
        }
        @media (min-width: ${THEME.BREAKPOINTS.XS}px) {
            .verticalShow__header img {
                width: 18%;
            }
            h2 {
                margin: 1.25rem;
                font-size: 4vw;
            }
            .verticalShow__about, .verticalShow__talent, .verticalShow__integration {
                padding: 0 .75rem;
                margin-bottom: .5rem;
            }
            h3 {
                font-size: 3.5vw;
            }
            p {
                font-size: 2.9vw;
            }
            .verticalShow__spacer {
              height: 15px;
            }
        }
        @media (min-width: 700px) {
            h3 {
                font-size: 3.5vw;
            }
            p {
                font-size: 2.75vw;
            }
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
            .verticalShow {
                padding: 0.5rem;
                grid-template-columns: 40% 1fr;
                grid-template-rows: auto;
                grid-template-areas:
                "header header"
                "img about"
                "img talent"
                "integration integration";
            }
            .verticalShow__header {
                grid-area: header;
            }
            .verticalShow__header img {
                width: 15%;
            }
            h2 {
                margin: 1.75rem;
                font-size: 3vw;
            }
            .verticalShow__img {
                grid-area: img;
                width: 100%;
            }
            .verticalShow__about {
                grid-area: about;
                padding: 0 .5rem;
            }
            .verticalShow__talent {
                grid-area: talent;
                padding: 0 .5rem 0;
                align-self: end;
            }
            .verticalShow__integration {
                grid-area: integration;
                border-top: 2px solid #C9C8C8;
                padding: .5rem 0 0;
            }
            h3 {
                font-size: 2.05vw;
            }
            p {
                font-size: 1.5vw;
            }
        }
        @media (min-width:  900px) {
            .verticalShow__header img {
                width: 14%;
            }
            p {
                font-size: 1.4vw;
            }
        }
        @media (min-width: ${THEME.BREAKPOINTS.MD}px) {
            .verticalShow {
                padding: 0.5rem;
                grid-template-columns: 2fr 2fr 1fr;
                grid-template-areas:
                "header header header"
                "img about integration"
                "img talent integration";
            }
            .verticalShow__about {
                grid-area: about;
                padding: .5rem;
            }
            .verticalShow__integration {
                grid-area: integration;
                border-top: none;
                border-left: 2px solid #C9C8C8;
                padding: 0 .75rem;
                margin: .5rem 0;
            }
            h3 {
                font-size: 1.5vw;
            }
            p {
                font-size: 1.2vw;
            }
            .verticalShow__spacer {
              height: 0px;
            }
        }
        @media (min-width: ${THEME.BREAKPOINTS.LG}px) {
            .verticalShow__header img {
                width: 12%;
            }
            h2 {
                margin: 1.75rem;
                font-size: 2.75vw;
            }
            h3 {
                font-size: 1.5vw;
            }
            p {
                font-size: 1.2vw;
            }
        }
        @media (min-width: ${THEME.BREAKPOINTS.XL}px) {
            h2 {
                margin: 2.25rem;
                font-size: 1.9rem;
            }
            h3 {
                font-size: 1.15rem;
            }
            p {
                font-size: .9rem;
            }
        }
      `}</style>
    </>
  )
}

export default VerticalShow
